import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,
    StatusBar,
    TouchableOpacity,
    KeyboardAvoidingView,
    ImageBackground,
    ActivityIndicator,
    Text,
    PermissionsAndroid,
    Linking, I18nManager,
    Image
} from "react-native";


import {scale, moderateScale, verticalScale} from '../../../tools/Scaling';


// import HMActionBarSatia from "../../customviews/HMActionBarSatia";


import i18n from '../../../I18n/i18n.js';
//import HMImageBackground from "../../customviews/HMImageBackground";

const SLIDER_1_FIRST_ITEM = 1;

import * as NavigationService from "../../../redux/NavigationService";
import DialogLoadingCustomize from "../../../customviews/DialogLoadingCustomize";
import HMTextView from "../../../customviews/HMTextView";
import Colors from "../../../tools/Colors";


// import HMLoading from "../../customviews/HMLoading";

import store from "../../../redux/store";
import {connect} from "react-redux";
import axios from "axios";
import {
    serviceActionAccount,
    serviceActionSetToken,
    serviceActionSuccess
} from "../../../screens/satia/splash/action/ActionSplashSatiaScreen";
import {AsyngStorageClass} from "../../../tools/AsyngStorageClass";
import {typeExport} from "../../../redux/store/type";
import DialogConnectionCustomize from "../../../customviews/DialogConnectionCustomize";
import HMActionBarSatia from "../../../customviews/HMActionBarSatia";
import {Tools} from "../../../tools/Tools";

let container = null

class ListAccountSatiaScreen extends Component {


    constructor(props) {
        super(props);
        container = this;
        this.state = {
            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,
            isLoading: false,
            indexSelectType: 0,
            // list: [],
            list: props.route && props.route.params && props.route.params.list ? props.route.params.list : (this.props.user && this.props.user.customers ? this.props.user.customers : []),
            /*    list: [
                    {
                        Serial: 1,
                        Name: 'رایانکده آپادانا',
                        Type: 'Wireless',

                    },
                    {
                        Serial: 2,
                        Name: 'وحید قایم مقامی',
                        Type: 'Wireless',

                    },
                    {
                        Serial: 3,
                        Name: 'وحید قایم مقامی',
                        Type: 'Wireless',

                    },
                    {
                        Serial: 4,
                        Name: 'دانشکده علوم پزشکی نهاوند',
                        Type: 'TD-LTE',

                    },
                    {
                        Serial: 5,
                        Name: 'وحید قایم مقامی',
                        Type: 'TD-LTE',

                    },
                    {
                        Serial: 6,
                        Name: 'ساتیا',
                        Type: 'TD-LTE',

                    },
                    {
                        Serial: 7,
                        Name: 'وحید قایم مقامی',
                        Type: 'ADSL',

                    },


                ],*/
            listFilter: []
        };

        // props.callServiceRefresh();


    }

    async componentDidMount() {


        let {list} = this.state
        if (!(list && list.length > 0)) {
            Tools.remove();

            setTimeout(function () {

                    try {

                        NavigationService.resetTo('SplashSatiaScreen')


                    } catch (e) {
                        NavigationService.navigatereset('SplashSatiaScreen')
                    }
                }.bind(this), 200
                //}.bind(this), 100
            );
        }
        // if (store.getState().reducerSplashGetAllData.TypeLogin == 2)
        //this.getData()

    }


    /*  getData() {

          this.setState({
              //ShowImage:true
              isLoading: true,
              NoInternetDialog: false,

          })


          const formData = new FormData();
          formData.append('lang', i18n.locale);
          formData.append('token', this.props.token);


          const config = {
              headers: {
                  "Content-Type": "multipart/form-data; charset=utf-8;",
                  // 'Content-Type': 'application/json',
                  // "Authorization": `Basic ${params.token}`,
                  timeout: Constants._TIMEOUT_FILE
              }
          };

          axios.post(typeExport._baseUrlSatia + "services/customerGigs", formData, config)
              .then(async response => {
                  let data = response.data;
                  let list = response.data.result && response.data.result.data ? response.data.result.data : response.data.result;


                  // data.status ? this.state.listImage.push(image) : null;

                  this.setState({
                      //ShowImage:true
                      list: data.status ? list : this.state.list,
                      //TypeDocumentsList:[],
                      isLoading: false,
                      NoInternetDialog: !data.status,

                  })
              }).catch((e) => {

              this.setState({
                  //ShowImage:true
                  isLoading: false,
                  NoInternetDialog: true,

              })
          })
      }*/

    render() {
        // let {} = this.props.route.params
        //let item = this.props.route.params ? this.props.route.params.item : null
        let account = this.props.DataSplashSatiaScreen.Account;
        return (
            <View style={{position: 'relative', flex: 1}}>


                {/*     <HMImageBackground

                />*/}

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBarSatia
                            menu={account}
                            back={account}
                            props={this.props} statusBarTransparent
                            text={"اشتراک ها"}
                            // text={item ? (item.name ? item.name : (item.title ? item.title : '')) : "اشتراک ها"}
                            //   text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}

                        />


                        <View style={{flex: 1}}>

                            {/*         {
                                item && item.user && item.user.message ?
                                    <View
                                        style={{
                                            width: '99%',
                                            // height: moderateScale(30),
                                            // flexDirection:'row',
                                            borderRadius: moderateScale(4),

                                            backgroundColor: item.user.message.BgColor ? item.user.message.BgColor : Colors.white,
                                            margin: moderateScale(4),
                                            alignItems: 'center',
                                            alignSelf: 'center',
                                            paddingVertical: moderateScale(4),
                                            borderWidth: moderateScale(1),
                                            borderColor: Colors.colorPrimary,

                                        }}>
                                        <HMTextView
                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                            text={item.user.message.Text}
                                            type={"bold"}
                                            style={{
                                                textAlign: "center",
                                                color: item.user.message.TxtColor ? item.user.message.TxtColor : Colors.colorDarkText,
                                                fontSize: moderateScale(12)

                                            }}/>
                                    </View>
                                    :
                                    null
                            }*/}
                            {
                                /*          this.state.list == null && this.state.isLoading ?
                                              <HMLoading/>

                                              :*/
                                <View style={{flex: 1}}>
                                    <View
                                        style={{
                                            width: "100%",
                                            height: moderateScale(40),
                                            //  width: typeExport.WIDTH - moderateScale(2),
                                            flexDirection: 'row',
                                            backgroundColor: Colors.white,
                                            alignSelf: 'center'
                                            // marginVertical:moderateScale(6),
                                        }}>
                                        <View style={{
                                            flex: .42,
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginVertical: moderateScale(4)
                                        }}>
                                            <HMTextView
                                                // numberOfLines={2}
                                                type={"bold"}
                                                text={"نام کاربری"}
                                                style={{
                                                    fontSize: moderateScale(14),

                                                    color: Colors.blackLight
                                                    //  marginTop: moderateScale(4),
                                                    //  textAlign: "right",
                                                }}/>
                                        </View>
                                        <View style={{
                                            height: '100%',
                                            width: moderateScale(1),
                                            alignSelf: 'center',
                                            backgroundColor: Colors.light43
                                        }}/>
                                        <View style={{flex: .21, alignItems: 'center', justifyContent: 'center'}}>
                                            <HMTextView
                                                // numberOfLines={2}
                                                type={"bold"}
                                                text={"نوع اشتراک"}
                                                style={{
                                                    fontSize: moderateScale(14),

                                                    color: Colors.blackLight,
                                                    //  marginTop: moderateScale(4),
                                                    textAlign: "center",

                                                }}/>
                                        </View>
                                        <View style={{
                                            height: '100%',
                                            width: moderateScale(1),
                                            alignSelf: 'center',
                                            backgroundColor: Colors.light43
                                        }}/>
                                        <View style={{flex: .21, alignItems: 'center', justifyContent: 'center'}}>
                                            <HMTextView
                                                // numberOfLines={2}
                                                type={"bold"}
                                                text={"وضعیت"}
                                                style={{
                                                    fontSize: moderateScale(14),

                                                    color: Colors.blackLight,
                                                    //  marginTop: moderateScale(4),
                                                    textAlign: "center",

                                                }}/>
                                        </View>
                                        <View style={{
                                            height: '100%',
                                            width: moderateScale(1),
                                            alignSelf: 'center',
                                            backgroundColor: Colors.light43
                                        }}/>
                                        <View style={{flex: .16, alignItems: 'center', justifyContent: 'center'}}>
                                            <HMTextView
                                                // numberOfLines={2}
                                                type={"bold"}
                                                text={"عملیات"}
                                                style={{
                                                    fontSize: moderateScale(14),

                                                    color: Colors.blackLight,
                                                    //  marginTop: moderateScale(4),
                                                    textAlign: "center",
                                                }}/>
                                        </View>


                                    </View>
                                    <View style={{
                                        width: '99%',
                                        height: moderateScale(1),
                                        alignSelf: 'center',
                                        backgroundColor: Colors.light43,
                                    }}/>
                                    <View
                                        style={{
                                            width: "100%",
                                            // height:moderateScale(40),
                                            //  width: typeExport.WIDTH - moderateScale(2),
                                            flexDirection: 'row',
                                            // backgroundColor: Colors.white,
                                            alignSelf: 'center'
                                            // marginVertical:moderateScale(6),
                                        }}>
                                        <FlatList
                                            style={{
                                                alignSelf: 'center',
                                                marginTop: moderateScale(6)
                                            }}
                                            // ItemSeparatorComponent={
                                            //     <View style={{
                                            //         width: '100%',
                                            //         height: moderateScale(1),
                                            //         backgroundColor: '#4f4f4f'
                                            //     }}/>
                                            // }
                                            // data={comment === null || !comment ? [] : comment}
                                            //     numColumns={1}
                                            //type => 1=  , 2= , 3= , 4= ,
                                            ///data={this.props.DataSplashSatiaScreen.results.listGig}
                                            data={this.state.list}
                                            renderItem={({item, index}) => {

                                                let Account = this.props.DataSplashSatiaScreen.Account                                            // let CheckAccount = Account ? (Account.Serial === item.Serial) : (index === 0);
                                                let CheckAccount = Account ? Account.Serial && item.Serial && (Account.Serial === item.Serial) : false;
                                                let indexAccount = this.props.DataSplashSatiaScreen.indexAccount;
                                                // let checkAccount=Account?Account:n
                                                return <TouchableOpacity
                                                    disabled={CheckAccount}
                                                    onPress={async () => {
                                                        store.dispatch(serviceActionSuccess(null));

                                                        await AsyngStorageClass.setAsyng("Account", item);
                                                        store.dispatch(serviceActionAccount(item, index));

                                                        try {
                                                            NavigationService.resetTo('SplashSatiaScreen')

                                                        } catch (e) {
                                                            NavigationService.navigatereset('SplashSatiaScreen')

                                                        }
                                                    }}
                                                    style={{
                                                        // width: "100%",

                                                        //  width: '100%',
                                                        flex: 1,


                                                        marginBottom: moderateScale(4),
                                                        borderRadius: moderateScale(6),
                                                        borderColor: CheckAccount ? Colors.green : '#d0d8df',
                                                        backgroundColor: Colors.white,
                                                        borderWidth: moderateScale(1),
                                                        overflow: 'hidden',
                                                        //  marginVertical: moderateScale(2),
                                                        // padding: moderateScale(6)
                                                    }}>

                                                    <View style={{
                                                        width: '100%',
                                                        height: moderateScale(40),
                                                        flexDirection: 'row',
                                                    }}>
                                                        <View style={{
                                                            flex: .42,
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}>
                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={item.AdslTel}
                                                                style={{
                                                                    fontSize: moderateScale(14),

                                                                    color: Colors.blackLight,
                                                                    //  marginTop: moderateScale(4),
                                                                    //  textAlign: "right",
                                                                    //   textAlign: "center",
                                                                    marginVertical: moderateScale(4),
                                                                    marginHorizontal: moderateScale(4),

                                                                }}/>
                                                        </View>
                                                        <View style={{
                                                            height: '100%',
                                                            width: moderateScale(2),
                                                            alignSelf: 'center',
                                                            backgroundColor: CheckAccount ? Colors.green : Colors.light43
                                                        }}/>
                                                        <View style={{
                                                            height: '100%',
                                                            width: moderateScale(1),
                                                            alignSelf: 'center',
                                                            backgroundColor: Colors.light43
                                                        }}/>
                                                        <View style={{
                                                            flex: .21,
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}>
                                                            <HMTextView
                                                                cammas
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={item.Type}
                                                                style={{
                                                                    fontSize: moderateScale(14),

                                                                    color: Colors.colorDarkText,
                                                                    marginHorizontal: moderateScale(2),
                                                                    //  marginTop: moderateScale(4),
                                                                    //  textAlign: "right",
                                                                }}/>
                                                        </View>
                                                        <View style={{
                                                            height: '100%',
                                                            width: moderateScale(1),
                                                            alignSelf: 'center',
                                                            backgroundColor: CheckAccount ? Colors.green : Colors.light43
                                                        }}/>
                                                        <View style={{
                                                            flex: .21,
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}>
                                                            <HMTextView
                                                                cammas
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={item.status && item.status.length > 0 ? item.status[0].Name : " _ "}
                                                                style={{
                                                                    fontSize: moderateScale(14),

                                                                    color: Colors.colorDarkText,
                                                                    marginHorizontal: moderateScale(2),
                                                                    //  marginTop: moderateScale(4),
                                                                    //  textAlign: "right",
                                                                }}/>
                                                        </View>
                                                        <View style={{
                                                            height: '100%',
                                                            width: moderateScale(1),
                                                            alignSelf: 'center',
                                                            backgroundColor: CheckAccount ? Colors.green : Colors.light43
                                                        }}/>
                                                        <View style={{
                                                            flex: .16,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            backgroundColor: CheckAccount ? Colors.green : Colors.colorSecondPrimary
                                                        }}>
                                                            <HMTextView
                                                                cammas
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={CheckAccount ? "انتخاب شد" : i18n.t('constant.Select')}
                                                                style={{
                                                                    fontSize: moderateScale(14),
                                                                    color: Colors.white,
                                                                    marginHorizontal: moderateScale(2),
                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",
                                                                }}/>
                                                        </View>


                                                    </View>


                                                </TouchableOpacity>
                                            }}


                                        />
                                    </View>
                                </View>

                            }


                            {
                                this.state.isLoading ?
                                    <DialogLoadingCustomize/>
                                    : null
                            }


                            {
                                this.state.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData()}/> : null
                            }
                        </View>

                    </KeyboardAvoidingView>
                </View>


            </View>
        );
    }


}

const mapStateToProps = state => {
    return {

        user: state.reducerSplashSatiaScreen.user,
        token: state.reducerSplashSatiaScreen.token,
        DataSplashSatiaScreen: state.reducerSplashSatiaScreen,

    };
};
const mapDispatchToProps = dispatch => {
    return {
        //  callServiceCommentScreen: (url, params, type, typeConnection, page, item_count, token) => dispatch(callWebserviceComment(url, params, type, typeConnection, page, item_count, token)),
        //   callServiceRtl: (data) => dispatch(serviceActionRtl(data)),

    }
};
export default connect(mapStateToProps, mapDispatchToProps)(ListAccountSatiaScreen);
